import { getCurrentUser } from '@/services/auth.service';
import { UpdatePasswordUser } from '@/services/user.service';
import React, { useEffect, useState } from 'react';
import { Button, Drawer, Form, Input, Message, useToaster } from 'rsuite';
import { useTranslation } from 'react-i18next'; // Add this import

const DrawerPassword = ({ open, setOpen }) => {
  const toaster = useToaster();
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const { t } = useTranslation();

  const [notMatch, setNotMatch] = useState(true);

  const user = getCurrentUser();

  useEffect(() => {
    setNotMatch(
      newPassword.length > 0 && repeatPassword.length > 0 && newPassword !== repeatPassword
    );
  }, [newPassword, repeatPassword]);
  const handleSubmit = async () => {
    if (oldPassword.length == 0 || newPassword.length == 0 || repeatPassword.length == 0) {
      toaster.push(
        <Message showIcon type="error" closable>
          {t('Fill in the fields!')}
        </Message>
      );
    } else if (notMatch) {
      toaster.push(
        <Message showIcon type="error" closable>
          {t('Passwords do not match!')}
        </Message>
      );
    } else {
      setLoading(true);
      const res = await UpdatePasswordUser(user.id, {
        newpassword: newPassword,
        oldpassword: oldPassword
      });

      console.log('res', res);

      if (res.status == 201) {
        toaster.push(
          <Message showIcon type="error" closable>
            {t(res.message)}
          </Message>,
          { duration: 7000 }
        );
        setLoading(false);
      } else if (res.status == 200) {
        toaster.push(
          <Message showIcon type="success" closable>
            {t(res.message)}
          </Message>
        );
        setLoading(false);
        setOpen();
      } else {
        setLoading(false);
        toaster.push(
          <Message showIcon type="error" closable>
            {t(res.message)}
          </Message>
        );
      }
    }
  };

  return (
    <Drawer open={open} onClose={() => setOpen(false)} size={400}>
      <Drawer.Header>
        <Drawer.Title>{t('Update Password')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary" loading={loading} disabled={loading}>
            {loading ? t('Saving...') : t('Save')}
          </Button>

          <Button onClick={() => setOpen(false)} appearance="subtle" disabled={loading}>
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Form fluid>
          <Form.Group controlId="subject">
            <Form.ControlLabel>{t('Old password')}</Form.ControlLabel>
            <Input
              value={oldPassword}
              onChange={e => {
                setOldPassword(e);
              }}
              type="password"
            />
          </Form.Group>
          <Form.Group controlId="subject">
            <Form.ControlLabel>{t('New password')}</Form.ControlLabel>
            <Input
              value={newPassword}
              onChange={e => {
                setNewPassword(e);
              }}
              type="password"
            />
          </Form.Group>
          <Form.Group controlId="subject">
            <Form.ControlLabel>{t('Confirm password')}</Form.ControlLabel>
            <Input
              value={repeatPassword}
              onChange={e => {
                setRepeatPassword(e);
              }}
              type="password"
            />
          </Form.Group>
          {notMatch && (
            <Message showIcon type="warning">
              <strong>{t('Passwords do not match!')}</strong>
            </Message>
          )}
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerPassword;
